import React from 'react';
import PropTypes from 'prop-types';
import EventControl from '../../../images/event-control.png';
import GeneralSecurity from '../../../images/general-security.png';
import TrafficControl from '../../../images/traffic-control.png';

const SecurityType = (props) => {
	const { changeEventType, toNextStep, JobEventTypeId } = props;
	return (
		<div className="form-panel panel panel-default text-center">
			<div className="panel-heading">
				<h4 className="panel-title text-primary">Get Started</h4>
			</div>
			<div className="panel-body container-fluid">
				<div className="row panel-row">
					<div className="col-xs-10 col-xs-offset-1 text-center">What will the officer be assisting with?</div>
				</div>
				<div className="row panel-row">
					<div className="col-xs-4">
						<label htmlFor="eventType1">
							<img src={GeneralSecurity} alt="General Security" className="security-type-image" />
							<div>General Security</div>
							<input
								className="event-type-radio"
								type="radio"
								id="eventType1"
								name="eventType"
								checked={JobEventTypeId === 1}
								onChange={() => changeEventType(1, 'General Security')}
							/>
						</label>
					</div>
					<div className="col-xs-4">
						<label htmlFor="eventType2">
							<img src={TrafficControl} alt="Traffic Control" className="security-type-image" />
							<div>Traffic Control</div>
							<input
								className="event-type-radio"
								type="radio"
								id="eventType2"
								name="eventType"
								checked={JobEventTypeId === 2}
								onChange={() => changeEventType(2, 'Traffic Control')}
							/>
						</label>
					</div>
					<div className="col-xs-4">
						<label htmlFor="eventType3">
							<img src={EventControl} alt="Event Control" className="security-type-image" />
							<div>Event Control</div>
							<input
								className="event-type-radio"
								type="radio"
								id="eventType3"
								name="eventType"
								checked={JobEventTypeId === 3}
								onChange={() => changeEventType(3, 'Event Control')}
							/>
						</label>
					</div>
				</div>
				<div className="row marketplace-action-buttons-container">
					<button
						type="button"
						disabled={Number.isSafeInteger(JobEventTypeId) === false}
						className="btn btn-primary col-xs-6 col-xs-offset-3"
						onClick={toNextStep}
					>
						Next
					</button>
				</div>
			</div>
		</div>
	);
};

SecurityType.propTypes = {
	toNextStep      : PropTypes.func.isRequired,
	changeEventType : PropTypes.func.isRequired,
	JobEventTypeId  : PropTypes.number.isRequired,
};

export default SecurityType;
